import React from "react";
import { useGetAccountPlanProps } from "../useGetAccountPlanProps";
import { AssuranceFeaturesCard } from "./AssuranceFeaturesCard";
import { CalculatingCard } from "./CalculatingCard";
import { EntityPlanCard } from "./EntityPlanCard";
import { TaxSavingCard } from "./TaxSavingCard";
import { TradingStockPlanCard } from "./TradingStockPlanCard";
import { TransactionCapCard } from "./TransactionCapCard";

export const UpsellCard = (): JSX.Element | null => {
  const {
    currentPlan,
    recommendedPlan,
    recommendedReason,
    isLoading: planPropsLoading,
    upgradeCost,
    totalGainDifference,
    yearlySavings,
    suitablePlans,
    account,
  } = useGetAccountPlanProps();

  const cheapestPlan = suitablePlans[0] ?? recommendedPlan;

  if (planPropsLoading || !account) {
    return <CalculatingCard />;
  } else if (!recommendedPlan || !upgradeCost) {
    return null;
  } else if (recommendedReason === "requiresTradingStock") {
    return (
      <TradingStockPlanCard
        recommendedPlan={recommendedPlan}
        cheaperPlan={cheapestPlan}
        currentPlan={currentPlan}
        account={account}
      />
    );
  } else if (recommendedReason === "transactionCapExceeded") {
    // exceeded transaction limit
    return (
      <TransactionCapCard
        recommendedPlan={recommendedPlan}
        cheaperPlan={cheapestPlan}
        currentPlan={currentPlan}
        account={account}
      />
    );
  } else if (recommendedReason === "requiresEntity") {
    return (
      <EntityPlanCard
        recommendedPlan={recommendedPlan}
        cheaperPlan={cheapestPlan}
        currentPlan={currentPlan}
        account={account}
      />
    ); // private wealth
  } else if (
    recommendedReason === "hasTaxSaving" &&
    totalGainDifference &&
    yearlySavings &&
    cheapestPlan
  ) {
    return (
      <TaxSavingCard
        recommendedPlan={recommendedPlan}
        cheaperPlan={cheapestPlan}
        currentPlan={currentPlan}
        yearlySavings={yearlySavings}
        account={account}
      />
    );
  } else if (
    recommendedPlan &&
    !currentPlan?.features.assuranceReports &&
    cheapestPlan
  ) {
    return (
      <AssuranceFeaturesCard
        recommendedPlan={recommendedPlan}
        cheaperPlan={cheapestPlan}
        currentPlan={currentPlan}
        account={account}
      />
    );
  } else {
    return null;
  }
};
